'use strict';

var _ = require('lodash');
var JqxGridSelectionController = function JqxGridSelectionController($scope) {
  var FEATURE_MODEL_ROOT = 'gridPanelScope.gridFeaturesModel.';
  var FEATURE_NAME = 'selection';
  var MODEL = FEATURE_MODEL_ROOT + FEATURE_NAME;
  function indexToRow(index) {
    return _.get($scope, 'gridPanelScope.jqxGridSettings.source.loadedData[' + index + ']');
  }
  $scope.updateSelectionModel = function () {
    var jqxGrid = $scope.gridPanelScope.getJqxGridElement();
    var selectedIndexes = jqxGrid.jqxGrid('getselectedrowindexes');
    _.set($scope, MODEL + '.selectedRows', _.map(selectedIndexes, indexToRow));
    _.set($scope, MODEL + '.selectedRowIndexes', selectedIndexes);
  };
  $scope.rowSelectionChange = function () {
    $scope.updateSelectionModel();
    $scope.$apply();
  };
  $scope.extendEventHandlers = function () {
    $scope.gridEventHandlers.selection = {
      rowselect: $scope.rowSelectionChange,
      rowunselect: $scope.rowSelectionChange
    };
  };
  $scope.extendFeaturesModel = function () {
    _.set($scope, MODEL + '.setSelection', $scope.setSelection);
    _.set($scope, MODEL + '.selectedRows', []);
    _.set($scope, MODEL + '.selectedRowIndexes', []);
  };
  $scope.extendSettings = function () {
    $scope.gridFeatures.selection = {
      selectionmode: 'multiple_checkboxes'
    };
  };
  $scope.setSelection = function (indexes) {
    var jqxGrid = $scope.gridPanelScope.getJqxGridElement();
    jqxGrid.jqxGrid('selectedrowindexes', indexes);
    jqxGrid.jqxGrid('refresh');
    $scope.updateSelectionModel();
  };
  $scope.registerFeature = function () {
    $scope.extendSettings();
    $scope.extendFeaturesModel();
    $scope.extendEventHandlers();
  };
  $scope.registerFeature();
};
JqxGridSelectionController.$inject = ['$scope'];
module.exports = JqxGridSelectionController;